import React, { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'

import './index.css'
import './i18n'
import { applyContentOverrides, subscribeContentLive } from './lib/content'

import App from './App'

// Wstrzyknij edytowalne teksty z bazy (nadpisują domyślne tłumaczenia) i utrzymuj je na żywo
applyContentOverrides()
subscribeContentLive()

ReactDOM.createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
